import { render, staticRenderFns } from "./KingsStudent.vue?vue&type=template&id=e6a0f8fa&"
import script from "./KingsStudent.vue?vue&type=script&lang=js&"
export * from "./KingsStudent.vue?vue&type=script&lang=js&"
import style0 from "./KingsStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports